import React from "react";
import { GamesWrapLazyContentsWebView } from "@/components/webview/games/GamesWrapLazyContentsWebView";
import GamesLazySectionsWebView from "@/components/webview/games/GamesLazySectionsWebView";
import { GameIntroWebView } from "@/components/webview/games/main/GameIntroWebView";

export const HomeWebView = () => {
  return (
    <>
      <GameIntroWebView className="min-h-[360px] rounded-lg px-4 pb-[38px]" />
      {/* lazy 하게 게임컴포넌트를 가져옵니다 */}
      <GamesWrapLazyContentsWebView contents={<GamesLazySectionsWebView />} />
    </>
  );
};
